const FIRMWARE_UPDATE = 'FIRMWARE_UPDATE';
const LOYALTY = 'LOYALTY';
const INFORMATIVE = 'INFORMATIVE';
const MARKETING = 'MARKETING';
const CONVERSION = 'CONVERSION';
const SYSTEM = 'SYSTEM';

export default {
    FIRMWARE_UPDATE,
    LOYALTY,
    INFORMATIVE,
    MARKETING,
    CONVERSION,
    SYSTEM,
};
